import React from 'react'
import '../Assets/css/loader.css'

function LoaderCustom({text}) {


  return (

        <div align="center" class="row">
            <div class="col-md-12 col-sm-12 col-xs-12">
                <h1 class="loadertitle">{text}</h1>
                <div class="loader">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                </div>
            </div>
        </div>
 
  )
}

export default LoaderCustom